



















import Widget from "@/components/common/Widget.vue";
import VerticalLineAndBarGroupChart from "@/components/charts_js/VerticalLineAndBarGroupChart.vue";
import DashboardItemWrapper from "@/components/DashboardItems/DashboardItemWrapper.vue";
import Vue from "vue";

import Component from "vue-class-component";
import store from "@/store";

@Component({
  components: {
    Widget,
    DashboardItemWrapper,
    VerticalLineAndBarGroupChart,
  },
})
export default class KostenGesamtVergleich extends Vue {
  public static id = "KostenGesamtVergleich";
  public static dprops = { width: 4, height: 4, minWidth: 2, minHeight: 2 };
  get _id() {
    return KostenGesamtVergleich.id;
  }
  get _dprops() {
    return KostenGesamtVergleich.dprops;
  }
  get planSelected() {
    return store.getters.planSelected;
  }
}
